
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, NavLink, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, DialogContent,
    TablePagination, Typography, InputAdornment, IconButton, Tooltip, Popover, Container, Divider, Snackbar
} from '@mui/material';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import { SearchOutlined } from '@mui/icons-material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import CompanyDetails from "./CompanyDetails";
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { editDeleteCompany, getCompanyList } from "../../../actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { dateConversionOnEntryPage } from "../../reusableComponent/dateConversionOnEntryPage";
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import { BackBtn } from "../../reusableComponent/BackBtn";

function CompanyDetailsList(props) {
    let navigate = useNavigate();
    let ref = useRef();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const [successMessage, setSuccessMessage] = useState(null);

    const tableRef = useRef(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }
    const [open, setOpen] = React.useState();
    const [openPopup, setOpenPopup] = React.useState(false);

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [isLoaded, setIsLoaded] = useState(false);

    const [q, setQ] = useState("");
    const [searchParam] = useState(["companyName", "gstIN", "panNo", "address", "city", "state", "pinCode", "logo_image", "logoHeight", "logoWidth", "startDate", "endDate"])
    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [info, setInfo] = useState({});

    const handleClose = () => {
        setIsDelete(false)
        setDeleteInfo(null);
        setOpenPopup(false);
    }
    const handleDelete = (info) => {
        setIsDelete(true);
        setDeleteInfo(info);
    }
    const getData = () => {
        dispatch(getCompanyList({ companyId: userInfo.userRole == 'superAdmin' ? null : userInfo.companyId }))
    }
    const rows = useSelector(state => state.company.company)
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.company.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                getData();
                setIsDelete(false);
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, getData]);


    const deleteRecord = () => {
        dispatch(editDeleteCompany({ id: deleteInfo.id, modifiedBy: userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }))
    }

    useEffect(() => {
        getData()
    }, []);


    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }


    const [sortBy, setSortBy] = useState(null);
    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows && rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            }
        });
    };

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const handleBack = () => {
        navigate(-1);
    }
    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    const fields = ['id', "companyName", "gstIN", "panNo", "address", "factoryAddress", "city", "state", "pinCode", "logoHeight", "logoWidth", "financialYear"];
    const labels = ['Id', "Company Name", "GSTIN", "PAN No.", "Address", "Factory Address", "City", "State", "Pincode", "Logo Height", "Logo Width", "Financial Year"];

    return (
        <>
         <Breadcrumb
                        routeSegments={[
                            { name: 'Settings', path: '/settings' },
                            { name: 'Company Details List' },
                        ]}
                    />
            <Paper className={`${styles.list_container}`}>
               
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={7} xs={0}>
                            {/* <Typography className={`${styles.page_title}`}>Company Details</Typography> */}
                        </Grid>
                        <Grid item md={5} xs={12} style={{ display: 'flex', float: 'right' }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Company Details"
                                />
                            </Box>
                            <TextField
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: '11px',
                                        paddingLeft: '1px',
                                    }
                                }}
                                type="search"
                                name="search"
                                placeholder="Search"
                                value={q}
                                size="small"
                                onChange={(e) => setQ(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" >
                                            <IconButton sx={{ padding: '4px' }}>
                                                <SearchOutlined sx={{ fontSize: '22px', marginRight: '4px' }} />
                                                <Divider orientation="vertical" flexItem />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            {userInfo.userRole == 'superAdmin' &&
                                <NavLink to={{ pathname: `/add-company-details` }} className={`${styles.underline}`}>
                                    <Button variant="contained" onClick={handleClickOpenPopup} className={`${styles.add_btn}`}>
                                        <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                                    </Button>
                                </NavLink>
                            }
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
                    <Table sx={{ minWidth: 1000 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('companyName')}>Company Name <span className={`${styles.sort_icon}`}> {sortBy === 'companyName' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('gstIN')}>GST No <span className={`${styles.sort_icon}`}> {sortBy === 'gstIN' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('panNo')}>Pan No<span className={`${styles.sort_icon}`}> {sortBy === 'panNo' ? '▲' : '▼'} </span> </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('address')}>Address <span className={`${styles.sort_icon}`}> {sortBy === 'address' ? '▲' : '▼'} </span></StyledTableCell>
                                
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('emailId')}>Email Id <span className={`${styles.sort_icon}`}> {sortBy === 'emailId' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('mobileNo')}>Mobile No <span className={`${styles.sort_icon}`}> {sortBy === 'mobileNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('city')}>City <span className={`${styles.sort_icon}`}> {sortBy === 'city' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('state')}>State <span className={`${styles.sort_icon}`}> {sortBy === 'state' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('pinCode')}>Pin Code <span className={`${styles.sort_icon}`}> {sortBy === 'pinCode' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} >Logo </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('logoHeight')}>Logo Height <span className={`${styles.sort_icon}`}> {sortBy === 'logoHeight' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('logoWidth')}>Logo Width <span className={`${styles.sort_icon}`}> {sortBy === 'logoWidth' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('financialYear')}>Financial Year <span className={`${styles.sort_icon}`}> {sortBy === 'financialYear' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('currency')}>Currency <span className={`${styles.sort_icon}`}> {sortBy === 'currency' ? '▲' : '▼'} </span></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows && search(rows)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                // .map((row) => (
                                .map((row, index) => (
                                    <StyledTableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >


                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                                            <PopupState variant="popover" popupId="demo-popup-popover">
                                                {(popupState) => (
                                                    <div>
                                                        <MoreHorizIcon
                                                            id={styles.actionBtn}
                                                            alt="translator"
                                                            variant="contained"
                                                            {...bindTrigger(popupState)}
                                                        />
                                                        <Popover
                                                            {...bindPopover(popupState)}
                                                            anchorOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                        >
                                                            <Container className={`${styles.tbl_action}`}>
                                                                <>
                                                                    <NavLink to={{ pathname: `/add-company-details` }} state={row} className={`${styles.underline}`}>
                                                                        <Button className={`${styles.list_tbl_action_btn}`}>
                                                                            <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                            <span style={{ marginRight: '13px' }}> Edit Record</span>
                                                                        </Button>
                                                                    </NavLink>
                                                                    {userInfo.userRole == 'superAdmin' &&
                                                                        <Button className={`${styles.list_tbl_action_btn}`} onClick={() => { handleDelete(row); popupState.close()}}>
                                                                            <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record
                                                                        </Button>
                                                                    }
                                                                </>
                                                            </Container>
                                                        </Popover>
                                                    </div>
                                                )}
                                            </PopupState>
                                        </StyledTableCell>

                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.companyName}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.gstIN}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.panNo}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.address}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.emailId}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.mobileNo}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.city}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.state}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.pinCode}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                                            <img height={'50px'} width={'50px'} src={row.logo_image} /></StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.logoHeight}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.logoWidth}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.financialYear}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.currency}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={{ px: 2, }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.companyName}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo.id)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        maxHeight: 600
                    }
                }}
                onClose={handleClose}
                open={openPopup}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    Create Company
                </BootstrapDialogTitle>
                <DialogContent dividers >
                    <CompanyDetails handleCloseDialog={handleClose} details={info} onAPISubmt={getData} />
                </DialogContent>
            </BootstrapDialog>


            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }
        </>
    )
}

export default CompanyDetailsList;
